













import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import conditionList from './json/conditionList.json'

export default Vue.extend({
  props: ['barId'],
  watch: {
    barId(val) {
      const data = conditionList as any
      this.dataList = data[this.barId].data
      this.unit = data[this.barId].unit
      this.check = false
      const params = { check: this.check, data: {} }
      this.$emit('checkCondition', params)
    },
  },
  data() {
    return {
      dataList: [] as any,
      check: false,
      checkText: '',
      unit: '',
    }
  },
  created() {
    const data = conditionList as any
    this.dataList = data[this.barId].data
    this.unit = data[this.barId].unit
  },
  methods: {
    checked() {
      this.check = false
      this.checkText = ''
      const params = { check: this.check, data: {} }
      this.$emit('checkCondition', params)
    },
    checkCondtion(item: any) {
      // 取消选择
      if (item.text === this.checkText) {
        this.check = false
        this.checkText = ''
      } else {
        this.check = true
        this.checkText = item.text
      }

      const params = { check: this.check, data: item }
      this.$emit('checkCondition', params)

    },
  },
})
